import { Component, computed, input, output } from '@angular/core';
import { Address } from '../../core/models/core/address.model';
import { IconNameType } from '../icons/icon-name-type.enum';
import { IconComponent } from '../icons/icon.component';
import { CommonModule } from '@angular/common';
import { IconUtils } from '../../core/utils/icon-utils';
@Component({
  selector: 'cwo-account-address',
  standalone: true,
  imports: [IconComponent, CommonModule],
  templateUrl: './account-address.component.html',
  styleUrl: './account-address.component.scss'
})
export class AccountAddressComponent {
  address = input.required<Address>();
  iconNameType = IconNameType;
  selected = input(false);

  readonly action = output<'select' | 'edit' | 'delete'>();

  addressInfo = computed(() => {
    return `${this.address().street}, ${this.address().city}, ${this.address().state?.toUpperCase()} ${this.address().zip}`;
  })

  icon = computed(() => {
    return IconUtils.calcAddressIcon(this.address().addressType)
  })
}
